import {textSizes, headingSizes} from '@stencil/build-theme';
import styled, {CSSProperties, keyframes, css} from 'styled-components';
import {
  slideUp,
  slideDown,
  customSlideDownFunc,
  customSlideUpFunc,
} from '../../stories/pages/util/common.styles';

const applyDynamicStyles = (styles?: CSSProperties) =>
  styles
    ? css`
        ${Object.entries(styles).map(([key, value]) => `${key}: ${value};`)}
      `
    : '';

export const ModalContainer = styled.div<{$isFullScreen?: boolean; animation?: Number}>`
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 101;
  opacity: 1;
  animation: ${props => (props.animation ? customSlideUpFunc(props.animation) : slideUp)} 0.2s
    ease-in-out;
  ${props => (props.$isFullScreen ? 'top: 0;' : '')}

  &.isClosed {
    animation: ${props => (props.animation ? customSlideDownFunc(props.animation) : slideDown)} 0.2s
      ease-in-out;
  }
  &.isHidden {
    visibility: hidden;
  }
`;

export const ModalInnerContainer = styled.div`
  position: relative;
  z-index: 9999;
  transform: translateY(0%);
  box-shadow: 0px 2px 4px rgba(20, 24, 35, 0.2);
`;

export const ModalBackdrop = styled.div`
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
`;

export const ModalBodyWrapper = styled.div`
  background: ${props => props.theme.colors.goWhite.base};
  position: relative;
  z-index: 10;
`;

export const ModalHeader = styled.div`
  padding: 2.4rem 1.6rem 1.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  .headerText {
    ${headingSizes.Small};
    color: ${props => props.theme.colors.downriver.base};
    margin-bottom: 0.2rem;
  }

  .headerTag {
    ${textSizes.SmallW3};
    padding: 0.8rem 1.2rem;
    color: ${props => props.theme.colors.goWhite.base};
    position: absolute;
    background: ${props => props.theme.colors.goBrandOrange.medium};
    border-radius: 0.8rem;
    top: -1.6rem;
  }

  .descText {
    ${textSizes.SmallW1};
    color: #777777;
  }
`;

export const CloseBtn = styled.span<{$closeBeforeAfterStyles?: CSSProperties}>`
  position: relative;
  width: 16px;
  height: 16px;
  padding: 10px;

  &::before,
  &::after {
    position: absolute;
    top: 2px;
    content: ' ';
    height: 2rem;
    width: 2px;
    background-color: ${props => props.theme.colors.downriver.base};

    /* Apply dynamic styles */
    ${({$closeBeforeAfterStyles}) => applyDynamicStyles($closeBeforeAfterStyles)}
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

export const ModalLeftWrapper = styled.div`
  display: flex;
`;

export const LeftButton = styled.a`
  position: relative;
  width: 16px;
  height: 16px;
  padding: 10px 25px 10px 10px;
  &:before,
  &:after {
    position: absolute;
    top: 2px;
    content: ' ';
    height: 16px;
    width: 2px;
    background-color: ${props => props.theme.colors.downriver.base};
  }

  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;

export const ModalContentWrapper = styled.div<{$isFullScreen?: boolean}>(
  props => `
    overflow:scroll; 
    max-height: ${props.$isFullScreen ? `100vh` : `70vh`};
    -ms-overflow-style: none; 
    scrollbar-width: none; 
  `,
);
